/**
 * Where a notification takes the staff member when they click it.
 *
 * Each in-app notification type declares its own jump target in its REQ. The backend
 * resolves that at send time into `targetType` + `dataId`, so the panel does not need
 * to know which notification type it is rendering.
 *
 * Not in the API yet — until it lands, no notification offers a jump button. See
 * docs/notification-api-backend-requests.md.
 */
export enum NotificationTargetType {
	/** No record page to open (e.g. the annual Face Sheet reminder). */
	none = 0,
	preAdmission = 1,
	admissionRequest = 2,
	member = 3,
	intervention = 4,
}
